import { observer } from 'mobx-react'
import './index.scss'
import { ReactComponent as ArrowDown } from '../../assets/arr-down.svg'
import { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'

const SeoBlock = observer(
  ({ seo, isLight = false }: { seo: any; isLight?: boolean }) => {
    const [open, setOpen] = useState(false)
    const ref = useRef<any>(null)

    useEffect(() => {
      if (!ref.current && !seo) return
      setTimeout(() => {
        ref.current.style.setProperty('--seo', ref.current.scrollHeight + 'px')
      }, 300)
    }, [seo])

    return (
      <section
        className={classNames('seo-block', open && 'show', isLight && 'light')}
      >
        <h1
          className="seo-block__title"
          dangerouslySetInnerHTML={{ __html: seo.title }}
        ></h1>
        <div
          className="seo-block__text"
          ref={ref}
          dangerouslySetInnerHTML={{ __html: seo.text }}
        ></div>
        <div className="seo-block__btn" onClick={() => setOpen(!open)}>
          {seo.button} <ArrowDown />
        </div>
      </section>
    )
  },
)

export default SeoBlock
